import { createFileRoute } from "@tanstack/react-router";

import { Content } from "@/features/dashboard/pedidos/$id/components/OrderIdContent";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  return <Content />;
}
